// @ts-nocheck legacy file transformed to TS
import styled from '@emotion/styled'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import omit from 'lodash/omit'
import { injectIntl } from 'react-intl'
import Dropdown from 'legacy/components/Dropdown'
import FlexRow from 'legacy/components/FlexRow'
import deprecatedAnalytics from 'legacy/common/deprecatedAnalytics'
import withRetailerRouter from 'legacy/common/withRouter'
import { ASYNC_STATES } from 'legacy/common/constants'
import { RegionLocationContext } from 'legacy/contexts/regionLocation/RegionLocationContext'

const Container = styled(FlexRow)`
  margin: 0;
  padding: 0;
`

const InventoryAreaShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
})

const RegionShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  inventory_areas: PropTypes.arrayOf(InventoryAreaShape),
})

@injectIntl
@withRetailerRouter
class RegionLocationDropdown extends Component<any> {
  static propTypes = {
    history: PropTypes.object.isRequired,
    query: PropTypes.object.isRequired,
    regions: PropTypes.arrayOf(RegionShape),
    inventoryAreas: PropTypes.arrayOf(InventoryAreaShape),
    analyticsEvent: PropTypes.string,
    useInventoryAreas: PropTypes.bool,
    showRegions: PropTypes.bool,
  }

  static defaultProps = {
    regions: [],
    inventoryAreas: [],
  }

  onRegionsChange = region_ids => {
    const { analyticsEvent } = this.props
    if (analyticsEvent) {
      deprecatedAnalytics.track(analyticsEvent, {
        source_type: 'region',
        source_value: region_ids,
      })
    }
    const query = { ...this.props.query }
    if (!region_ids.length) {
      delete query.region_ids
    } else {
      query.region_ids = region_ids
    }
    this.props.history.push({
      query: omit(query, ['inventory_area_ids']),
    })
  }

  onInventoryAreasChange = inventory_area_ids => {
    const { analyticsEvent } = this.props
    if (analyticsEvent) {
      deprecatedAnalytics.track(analyticsEvent, {
        source_type: 'warehouse_location',
        source_value: inventory_area_ids,
      })
    }
    const query = { ...this.props.query }
    if (!inventory_area_ids.length) {
      delete query.inventory_area_ids
    } else {
      query.inventory_area_ids = inventory_area_ids
    }
    this.props.history.push({
      query: {
        ...query,
        inventory_area_ids,
      },
    })
  }

  optionify(values) {
    return values.map(({ id, name, street }) => ({
      label: name || street,
      value: id.toString(),
    }))
  }

  render() {
    const { intl } = this.props

    return (
      <RegionLocationContext.Consumer>
        {({
          regions,
          locations,
          inventoryAreas,
          regionStatus,
          locationStatus,
          inventoryAreaStatus,
        }) => (
          <Container>
            {this.props.showRegions && (
              <Dropdown
                width="200px"
                defaultable
                filterable
                isBusy={regionStatus === ASYNC_STATES.BUSY || regionStatus === ASYNC_STATES.IDLE}
                defaultText={intl.formatMessage({ id: 'filters.region.all' })}
                options={this.optionify(regions)}
                value={this.props.query.region_ids}
                onChange={this.onRegionsChange}
              />
            )}
            <Dropdown
              width="400px"
              defaultable
              filterable
              isBusy={
                this.props.useInventoryAreas
                  ? inventoryAreaStatus === ASYNC_STATES.BUSY ||
                    inventoryAreaStatus === ASYNC_STATES.IDLE
                  : locationStatus === ASYNC_STATES.BUSY || locationStatus === ASYNC_STATES.IDLE
              }
              defaultText={intl.formatMessage({ id: 'filters.location.all' })}
              options={this.optionify(this.props.useInventoryAreas ? inventoryAreas : locations)}
              value={this.props.query.inventory_area_ids}
              onChange={this.onInventoryAreasChange}
            />
          </Container>
        )}
      </RegionLocationContext.Consumer>
    )
  }
}

export default RegionLocationDropdown
